module.exports = __webpack_public_path__ + "img/INVERSER_PRENOM_NOM.a8fc36fe.svg";